<template>
  <no-icon-card
    :class="{
      'highlighted': highlighted,
    }"
  >
    <template #title>
      Explanation
    </template>
    <div
      class="rationale"
      v-html="rationale"
    ></div>
  </no-icon-card>
</template>

<script>
import NoIconCard from './NoIconCard.vue';

export default {
  components: {
    NoIconCard,
  },
  props: {
    rationale: {
      type: String,
      default: 'the rationale',
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
/* last child of class rationale should have a margin-bottom of 0, and this is a deep property */
.rationale {
  p:last-child {
    margin-bottom: 0;
  }
}

.highlighted {
  background-color: #EFF4FF;
  border: 1px solid #D1E0FF;
  border-radius: 8px;
}
</style>
